// ============================================================
// OMYA Digital Plant – German Translation Dictionary
// Usage: import { t } from '@/i18n';  then t('key')
// ============================================================

const de = {
  // ── Navigation ──
  'nav.main': 'HAUPTMENÜ',
  'nav.additional': 'WEITERE',
  'nav.dashboard': 'Übersicht',
  'nav.supplyChain': 'Produktionskette',
  'nav.trucks': 'Ankünfte',
  'nav.planning': 'Planung',
  'nav.orders': 'Aufträge',
  'nav.sapIntegration': 'SAP-Integration',
  'nav.aiVision': 'KI / VISION',
  'tour.open': 'Rundgang',
  'tour.next': 'Weiter',
  'tour.prev': 'Zurück',
  'tour.done': 'Fertig',
  'tour.welcome.title': 'Willkommen bei OMYA Digital Plant',
  'tour.welcome.text': 'In 2 Minuten zeigen wir, wie das Tool die Lkw-Ankünfte in Pomezí regelt: Heute kommen täglich 10–15 Fahrzeuge nicht und melden sich nicht ab. Sie können den Rundgang jederzeit schliessen und neu starten.',
  'tour.states.title': 'Stand der heutigen Verladungen',
  'tour.states.text': 'Auf einen Blick sehen Sie, wie viele Verladungen ohne Information sind. Genau diese Zahl wollen wir jeden Tag so weit wie möglich senken.',
  'tour.perHour.title': 'Ankünfte pro Stunde',
  'tour.perHour.text': 'Zeigt die Spitzen 6–9 und 12–14 Uhr gegenüber der Torkapazität. Wir schreiben niemandem Zeitfenster vor, wir wissen nur, was auf uns zukommt. Rot sind Fahrzeuge, über die wir nichts wissen.',
  'tour.banner.title': 'Was eine Aktion braucht',
  'tour.banner.text': 'Die Übersicht zeigt nur, was passiert. Hier sehen Sie, wie viele Verladungen ein Eingreifen brauchen, und kommen mit einem Klick in die Aktionsliste.',
  'tour.queue.title': 'Aktionsliste',
  'tour.queue.text': 'Der Planer sieht nur, was zu lösen ist: nachfassen, anrufen, dem Disponenten einen Link senden, umplanen. Was gelöst ist, verschwindet aus der Liste. Ziel ist eine leere Liste.',
  'tour.urgency.title': 'Nachfrage bei Spediteuren um 13:00',
  'tour.urgency.text': 'Um 13:00 vergleicht das System Plan und Ist und kontaktiert selbst den richtigen Spediteur per SMS, WhatsApp oder E-Mail, in seiner Sprache. Der Disponent gibt nur frei, oder es läuft voll automatisch.',
  'tour.replies.title': 'Antworten kommen live',
  'tour.replies.text': 'Jetzt läuft die Vorführung: Die KI liest Antworten auf Polnisch, GPS findet ein Fahrzeug unterwegs, und wer nicht binnen 30 Minuten antwortet, wird angerufen. Die Liste leert sich von selbst, dem Planer bleiben zwei Verladungen.',
  'tour.stats.title': 'Ergebnisse in Zahlen',
  'tour.stats.text': 'Langfristige Statistiken: Nichterscheinen ohne Avis, Anteil der Verladungen mit Information um 13:00, Nachfragen und Fahrzeuge auf dem Parkplatz in Jeseník, immer im Vergleich zum Stand vor dem Pilot.',
  'tour.carriers.title': 'Spediteursbewertung',
  'tour.carriers.text': 'Wer avisiert, wer nicht erscheint und wie schnell geantwortet wird. Grundlage für operative Verträge und Preisverhandlungen.',
  'tour.restart.title': 'Rundgang jederzeit erneut',
  'tour.restart.text': 'Mit dieser Schaltfläche starten Sie den Rundgang erneut, etwa für Kollegen. Vielen Dank für Ihre Aufmerksamkeit.',
  'nav.stats': 'Statistiken',
  'stats.title': 'Statistiken',
  'stats.demoData': 'Demodaten',
  'stats.demoHint': 'Illustratives Beispiel: So würden die Statistiken nach Einführung der Spediteur-Nachfrage aussehen. Ausgangswerte laut Kunde.',
  'stats.kpiPeriod': 'Durchschnitt der letzten 30 Tage gegenüber der Zeit vor dem Pilot',
  'stats.tab.overview': 'KPI-Übersicht',
  'stats.tab.carriers': 'Spediteure',
  'stats.carrier.name': 'Spediteur',
  'stats.carrier.trucks': 'Fzg.',
  'stats.carrier.loadings': 'Verladungen',
  'stats.carrier.announcedPct': 'Avisiert',
  'stats.carrier.noShowPct': 'Nichterscheinen ohne Avis',
  'stats.carrier.outOfHours': 'Keine Lenkzeit',
  'stats.carrier.replyMedian': 'Antwort (Median)',
  'stats.carrier.onTimePct': 'ETA ±30 min',
  'stats.carrier.legend': 'Pfeile: Veränderung gegenüber dem vorherigen Zeitraum gleicher Länge (grün = besser). Rot: Nichterscheinen ohne Avis ab 15 %. Klicken Sie auf einen Spediteur für den Verlauf.',
  'stats.carrier.weeklyNoShows': 'Nichterscheinen ohne Avis pro Woche',
  'stats.carrier.weeklyOnTime': 'ETA-Genauigkeit pro Woche',
  'stats.carrier.detailHint': 'Grundlage für operative Verträge und Preisverhandlungen mit dem Spediteur. Demodaten.',
  'rating.title': 'Monatliche Spediteursbewertung',
  'rating.open': 'Monatsbewertung zum Drucken',
  'rating.back': 'Zurück zu Spediteuren',
  'rating.month': 'Monat',
  'rating.partial': 'unvollständig',
  'rating.print': 'Drucken',
  'rating.workDays': '{days} Arbeitstage',
  'rating.pilotShare': 'automatische Nachfrage an {pct} % der Tage',
  'rating.thisMonth': 'Dieser Monat',
  'rating.prevMonth': 'Vormonat',
  'rating.change': 'Veränderung',
  'rating.findings': 'Feststellungen',
  'rating.finding.noShowAlarm': 'Nichterscheinen ohne Avis über dem Grenzwert von 15 %: Thema für den Betriebsvertrag.',
  'rating.finding.noShowBetter': 'Nichterscheinen ohne Avis gegenüber dem Vormonat gesunken.',
  'rating.finding.noShowWorse': 'Nichterscheinen ohne Avis gegenüber dem Vormonat gestiegen.',
  'rating.finding.slowReply': 'Antwortet langsam auf Nachfragen (Median über 30 min).',
  'rating.finding.onTime': 'Zuverlässige ETA: 90 % und mehr der Ankünfte im Fenster ±30 min.',
  'rating.notes': 'Gesprächsnotizen',
  'rating.footer': 'OMYA Pomezí · Demodaten, Kennzahlen wie in der Spediteursbewertung unter Statistiken.',
  'csv.export': 'CSV-Export',
  'csv.date': 'Datum',
  'csv.pilot': 'Pilot',
  'csv.planned': 'Geplante Verladungen',
  'csv.country': 'Land',
  'csv.yes': 'ja',
  'csv.no': 'nein',
  'stats.tab.site': 'Werksgelände',
  'stats.tab.reports': 'Berichte',
  'reports.readyToConnect': 'Bereit zur Anbindung',
  'reports.send': 'Per E-Mail senden',
  'reports.sendToast': 'Der E-Mail-Versand ist bereit zur Anbindung. In der Demo wird nichts gesendet.',
  'reports.daily.title': 'Tageszusammenfassung',
  'reports.daily.schedule': 'Geht jeden Arbeitstag um 16:00 an Disposition und Versand',
  'reports.daily.planned': 'Geplant',
  'reports.daily.loaded': 'Verladen',
  'reports.daily.urgencies': 'Nachfragen: {total}, davon {auto} automatisch gelöst und {planner} an den Disponenten übergeben.',
  'reports.daily.missing': 'Wer nicht kam',
  'reports.daily.open': 'Offen geblieben, Disponent kümmert sich',
  'reports.daily.none': 'Nichts',
  'reports.weekly.title': 'Wochenbericht für die Leitung',
  'reports.weekly.schedule': 'Geht montags um 7:00 raus',
  'reports.weekly.thisWeek': 'Diese Woche',
  'reports.weekly.worst': 'Problematischste Spediteure',
  'reports.weekly.noShowShort': 'ohne Avis',
  'stats.site.heatmapTitle': 'Ankünfte nach Tag und Stunde',
  'stats.site.heatmapHint': 'Durchschnittliche Ankünfte pro Stunde. Torkapazität: {capacity} / h',
  'stats.site.heatmapLegend': 'Je dunkler, desto näher an der Torkapazität. Rot: mehr Fahrzeuge, als das Tor pro Stunde abfertigt. Die Kapazitäten sind Richtwerte und werden vom Werk bestätigt.',
  'stats.site.gate.CLS': 'CLS (Silo)',
  'stats.site.gate.PST': 'PST (Paletten)',
  'stats.site.dwellTitle': 'Verweildauer im Werk',
  'stats.site.dwellHint': 'Median im gewählten Zeitraum; 90 % der Fahrzeuge sind innerhalb der angegebenen Zeit fertig',
  'stats.site.silo': 'Silo',
  'stats.site.pallet': 'Paletten',
  'stats.site.p90': '90 % bis',
  'stats.site.dwellMinutes': 'Im Werk gesamt (Tor → Abfahrt)',
  'stats.site.waitMinutes': 'Wartezeit vor Verladung',
  'stats.site.loadMinutes': 'Verladung',
  'stats.last30': '30 Tage',
  'stats.last90': '90 Tage',
  'stats.beforePilot': 'vor dem Pilot',
  'stats.pilotStart': 'Pilotstart',
  'stats.unit.perDay': '/ Tag',
  'stats.unit.trucksPerNight': 'Fzg. / Nacht',
  'stats.kpi.noShows': 'Nichterscheinen ohne Avis',
  'stats.kpi.informed': 'Verladungen mit Information um 13:00',
  'stats.kpi.urgencies': 'Nachfragen bei Spediteuren',
  'stats.kpi.autoResolved': 'automatisch gelöst',
  'stats.kpi.parking': 'Parkplatz Jeseník',
  'stats.chart.noShows': 'Nichterscheinen ohne Avis pro Tag',
  'stats.chart.noShowsHint': 'Fahrzeuge, die nicht kamen und sich nicht meldeten. Vor dem Pilot 10–15 täglich (laut Kunde).',
  'stats.chart.informed': 'Verladungen mit Information um 13:00',
  'stats.chart.informedHint': 'Anteil der heutigen Verladungen, bei denen wir um 13:00 wissen, ob und wann sie kommen.',
  'stats.chart.urgencies': 'Nachfragen: automatisch vs. durch Disponenten gelöst',
  'stats.chart.urgenciesHint': 'Vor dem Pilot fragte der Disponent manuell nach, und niemand erfasste es.',
  'stats.chart.parking': 'Fahrzeuge auf dem Parkplatz Jeseník pro Nacht',
  'stats.chart.parkingHint': 'Weniger Fahrzeuge ohne Lenkzeit und ohne Avis bedeuten weniger Bedarf am Auffangparkplatz.',
  'stats.series.auto': 'Automatisch',
  'stats.series.planner': 'Disponent',
  'stats.tab.urgency': 'Nachfragen',
  'stats.urgency.period': 'Pilottage im Zeitraum: {days}, Nachfragen gesamt: {total}',
  'stats.urgency.replyPct': 'Antwortquote',
  'stats.urgency.replyMedian': 'Median Antwortzeit',
  'stats.urgency.escalated': 'Eskalation zu Anruf',
  'stats.urgency.escalatedHint': 'Keine Antwort binnen 30 min',
  'stats.urgency.resolution': 'Automatisch / Disponent',
  'stats.urgency.resolutionHint': 'Selbst gelöst vs. an Disponenten übergeben',
  'stats.urgency.byChannel': 'Nachfragen nach Kanal',
  'stats.urgency.channel': 'Kanal',
  'stats.urgency.sent': 'Gesendet',
  'stats.urgency.cost': 'Kosten',
  'stats.urgency.czk': 'Kč',
  'stats.urgency.channelLegend': 'Die erste Nachricht geht über den Kanal, den der Spediteur nutzt. Ohne Antwort binnen 30 Minuten folgt ein Sprachanruf, danach der Disponent. Die Antwortzeit beim Anruf wird ab dem Wählen gemessen.',
  'stats.urgency.savingsTitle': 'Geschätzte Einsparung pro Monat',
  'stats.urgency.hoursPerMonth': 'h / Monat',
  'stats.urgency.savedHours': 'Eingesparte Zeit des Disponenten: Nachfragen, die er nicht mehr manuell erledigen muss',
  'stats.urgency.czkPerMonth': 'Kč / Monat',
  'stats.urgency.channelCost': 'Kosten für Nachrichten und Anrufe',
  'stats.urgency.assumption': 'Annahme: Eine manuelle Nachfrage kostet den Disponenten {minutes} min (Kontakt suchen, anrufen, Ergebnis notieren), ein Monat hat {days} Arbeitstage. Preise pro Nachricht oder Anruf: {prices}. Demodaten, Preise als Richtwerte.',
  'nav.views': 'Seitenansichten',
  'ai.live': 'KI',
  'ai.demo': 'KI-Demo',
  'ai.liveHint': 'Antwort von Claude (KI).',
  'ai.demoHint': 'Vorbereitete Demo-Antwort: Der KI-Schlüssel ist noch nicht gesetzt oder die KI hat nicht geantwortet.',
  'stats.value.title': 'Wert des Pilots für das Werk',
  'stats.value.month': 'Monat',
  'stats.value.roi': 'Amortisation {roi}× bei {price} pro Monat',
  'stats.value.parking': 'Parkplatz Jeseník',
  'stats.value.parkingCalc': 'Lkw pro Nacht {before} → {now} (−{pct} %) von {cost} Kč im Monat',
  'stats.value.noShows': 'Weniger Nichterscheinen ohne Avis',
  'stats.value.noShowsCalc': '{count} weniger Nichterscheinen im Monat × {cost} Kč',
  'stats.value.planner': 'Zeit des Disponenten',
  'stats.value.plannerCalc': '{hours} h × {cost} Kč',
  'stats.value.messages': 'Kosten für Nachrichten und Anrufe',
  'stats.value.messagesCalc': 'SMS, WhatsApp, E-Mail, Sprachanrufe',
  'stats.value.source.client': 'Zahl vom Kunden',
  'stats.value.source.estimate': 'unsere Schätzung',
  'stats.value.noShowCostInput': 'Kosten eines Nichterscheinens',
  'stats.value.priceInput': 'Softwarepreis pro Monat',
  'stats.value.note': 'Parkkosten und Kosten pro Nichterscheinen klären wir mit den Zahlen von OMYA.',
  'ai.energy.title': 'Empfohlener Mahlplan für morgen',
  'ai.energy.hint': 'Die KI legt die Mühlen in die günstigsten Stunden nach OTE-Preisen. Kosten und Ersparnis berechnet die App.',
  'ai.energy.recommend': 'Plan empfehlen (KI)',
  'ai.energy.habit': 'Heute (Start um 6:00)',
  'ai.energy.plan': 'Laut Empfehlung',
  'ai.energy.saving': 'Ersparnis pro Tag',
  'ai.energy.legend': 'Farbe = Preisband (grün günstig, rot Spitze), Umriss = heutige Gewohnheit. Preise: OTE-Modellwerktag.',
  'ai.doc.title': 'Dokument aus Foto',
  'ai.doc.upload': 'Dokument fotografieren oder hochladen',
  'ai.doc.expected': 'erwartet',
  'ai.doc.attach': 'Zur Verladung speichern',
  'ai.doc.attached': 'In der Kommunikation gespeichert.',
  'ai.doc.tooLarge': 'Die Datei ist grösser als 4,8 MB.',
  'ai.doc.allMatch': 'alles stimmt mit der Verladung überein',
  'ai.doc.type.cmr': 'CMR',
  'ai.doc.type.weighbridge': 'Wiegeschein',
  'ai.doc.type.delivery-note': 'Lieferschein',
  'ai.doc.type.other': 'Anderes Dokument',
  'ai.doc.field.plate': 'Kennzeichen',
  'ai.doc.field.orderId': 'Lieferung',
  'ai.doc.field.weight': 'Gewicht',
  'ai.voice.call': 'Mit KI-Stimme anrufen:',
  'ai.voice.ringing': 'Wähle…',
  'ai.voice.inProgress': 'Gespräch läuft',
  'ai.voice.ended': 'Gespräch beendet',
  'ai.voice.simulation': 'Simulierter Anruf',
  'ai.voice.result': 'Ergebnis',
  'ai.voice.noAnswer': 'Die Disposition nimmt nicht ab, die Verladung geht an den Disponenten.',
  'import.photo.upload': 'Foto oder PDF hochladen',
  'import.photo.read': 'Die KI hat {n} Zeilen gelesen, bitte unten prüfen.',
  'import.photo.demoNote': 'Ohne KI-Schlüssel wird statt der Datei der Beispielplan geladen.',
  'import.photo.tooLarge': 'Die Datei ist grösser als 4,8 MB.',
  'ai.assistant.title': 'KI-Assistent',
  'ai.assistant.ask': 'Assistenten fragen',
  'ai.assistant.thinking': 'Einen Moment…',
  'ai.assistant.back': 'Zurück zur Suche',
  'ai.brief.prepare': 'Gesprächsunterlagen vorbereiten (KI)',
  'ai.brief.title': 'Unterlagen für das Spediteursgespräch',
  'ai.brief.goal': 'Ziel',
  'ai.brief.arguments': 'Argumente',
  'ai.brief.proposals': 'Vorgeschlagene Bedingungen',
  'ai.brief.agreements': 'Was vereinbaren',
  'ai.brief.note': 'KI-Entwurf aus den Zahlen des Monats. Vor dem Gespräch prüfen und anpassen.',
  'ai.replan.propose': 'Lösung vorschlagen (KI)',
  'ai.replan.title': 'Vorschlag zur Umplanung',
  'ai.replan.risk': 'Risiko',
  'ai.replan.accept': 'Annehmen',
  'ai.replan.reject': 'Ablehnen',
  'ai.replan.accepted': 'Angenommen: Die Verladung ist umgeplant, vermerkt in der Kommunikation.',
  'ai.replan.rejected': 'Abgelehnt, der Plan bleibt unverändert.',
  'ai.comment.title': 'KI-Kommentar',
  'ai.comment.loading': 'Kommentar wird geschrieben…',
  'ai.ask.title': 'Statistik fragen',
  'ai.ask.placeholder': 'Z. B. Welcher Spediteur erscheint am häufigsten ohne Avis nicht?',
  'ai.ask.send': 'Fragen',
  'ai.ask.source': 'Quelle',
  'ai.ask.q1': 'Wie viele Lkw erscheinen ohne Avis nicht, und wie war es vor dem Pilot?',
  'ai.ask.q2': 'Welcher Spediteur ist am problematischsten?',
  'ai.ask.q3': 'Wie viel Zeit hat die automatische Nachfrage gespart?',
  'ai.ask.q4': 'Wie entwickelt sich der Anteil informierter Verladungen um 13:00?',
  'ai.reply.title': 'Spediteur-Antwort simulieren',
  'ai.reply.placeholder': 'Antwort des Spediteurs eingeben, z. B. auf Polnisch…',
  'ai.reply.read': 'Antwort erkennen',
  'ai.reply.unclear': 'Unklar',
  'ai.reply.confidence': 'Sicherheit',
  'ai.reply.reason': 'Grund',
  'ai.reply.noTranslation': 'Die Übersetzung braucht die KI mit Schlüssel.',
  'ai.reply.applied': 'Automatisch übernommen, die Antwort steht in der Kommunikation.',
  'ai.reply.confirm': 'Bestätigen',
  'ai.reply.dismiss': 'Verwerfen',
  'ai.reply.readByAi': 'von KI erkannt',
  'nav.focus': 'AKTUELLER FOKUS',
  'nav.concepts': 'IDEEN / KONZEPTE',
  'nav.conceptsHint': 'Ideen für später, noch ohne echte Daten',
  'concept.badge': 'Konzept',
  'concept.hint': 'Beispiel einer möglichen Erweiterung. Die Daten sind illustrativ, und das Modul ist noch nicht Teil des Pilots.',
  'nav.branchDetection': 'Asterkennung',
  'nav.visualFactory': 'Visual Factory',

  // ── Detekce větví ──
  'branchDetection.title': 'Asterkennung',
  'branchDetection.description': 'KI-Modul zur Erkennung von Ästen auf dem Förderband. Erkennt unerwünschte Verunreinigungen im Gestein in Echtzeit.',
  'branchDetection.demo': 'Erkennungsdemo',
  'branchDetection.detected': 'Erkannt',
  'branchDetection.branches': 'Äste',
  'branchDetection.accuracy': 'Genauigkeit',
  'branchDetection.zone': 'Erkennungszone',
  'branchDetection.live': 'Live',
  'branchDetection.label': 'Ast',
  'branchDetection.shift.title': 'Frühschicht: Funde auf dem Band',
  'branchDetection.shift.total': 'Funde',
  'branchDetection.shift.perHour': 'Funde pro Stunde',
  'branchDetection.shift.note': 'Konzept-Demo mit Beispieldaten. Eine echte Version braucht eine Kamera über dem Band und ein trainiertes Bildmodell.',
  'branchDetection.outcome.ejected': 'Per Klappe ausgeschleust',
  'branchDetection.outcome.review': 'Zu prüfen',
  'branchDetection.outcome.false': 'Fehlalarm',

  // ── Header ──
  'header.search': 'Suchen',
  'header.notifications': 'Benachrichtigungen',
  'header.activeAlerts': 'aktive Warnungen',
  'header.markAllRead': 'Alle gelesen',
  'header.allClear': 'Alles in Ordnung',
  'header.live': 'LIVE',
  'header.profile': 'Profil',
  'header.settings': 'Einstellungen',
  'header.signOut': 'Abmelden',
  'header.justNow': 'gerade eben',
  'header.minAgo': 'Min. her',
  'header.hrAgo': 'Std. her',
  'header.dAgo': 'T. her',
  'header.language': 'Sprache',

  // ── Command Palette ──
  'cmd.placeholder': 'Aufträge, Lkw, Knoten suchen...',
  'cmd.noResults': 'Keine Ergebnisse.',
  'cmd.pages': 'Seiten',
  'cmd.orders': 'Aufträge',
  'cmd.trucks': 'Lkw',
  'cmd.supplyChainNodes': 'Knoten der Produktionskette',
  'cmd.util': 'Auslastung',

  // ── Dashboard ──
  'dashboard.title': 'Übersicht',
  'dashboard.plant': 'Werk Pomezí',
  'dashboard.totalOutputToday': 'Gesamtausstoss heute',
  'dashboard.morningShift': 'Frühschicht',
  'dashboard.afternoonShift': 'Spätschicht',
  'dashboard.nightShift': 'Nachtschicht',
  'dashboard.all': 'Alle',
  'dashboard.am': 'Früh',
  'dashboard.pm': 'Spät',
  'dashboard.night': 'Nacht',
  'dashboard.operationsActive': 'Betrieb aktiv',
  'dashboard.linesInOperation': 'Linien in Betrieb',
  'dashboard.loadings': 'Verladungen',
  'dashboard.todaysOutput': 'Ausstoss heute',
  'dashboard.vsYesterday': 'vs. gestern',
  'dashboard.plantUtilization': 'Werksauslastung',
  'dashboard.linesActive': 'aktive Linien',
  'dashboard.oee': 'OEE',
  'dashboard.loadingsToday': 'Verladungen heute',
  'dashboard.remaining': 'offen',
  'dashboard.qualityRate': 'Qualität',
  'dashboard.energyCost': 'Energiekosten',
  'dashboard.costPerTonne': 'Kosten pro Tonne',
  'dashboard.costPerTonneSub': 'Live-OTE × Mahlverbrauch',
  'dashboard.offPeakUntil': 'NIEDERTARIF bis 14:00',
  'dashboard.productionLast7Days': 'Produktion – letzte 7 Tage',
  'dashboard.actual': 'Ist',
  'dashboard.target': 'Ziel',
  'dashboard.lineUtilization': 'Linienauslastung',
  'dashboard.utilization': 'Auslastung',
  'dashboard.activeAlerts': 'Aktive Warnungen',
  'dashboard.oeeFull': 'OEE (Gesamtanlageneffektivität)',

  // ── KPI Card ──
  'kpi.target': 'Ziel',
  'kpi.offPeakUntil14': 'NIEDERTARIF bis 14:00',

  // ── KPI Drilldown ──
  'drilldown.title': 'Detail',
  'drilldown.todayHourly': 'Heute (stündlich)',
  'drilldown.thisWeek': 'Diese Woche',
  'drilldown.thisMonth': 'Dieser Monat',
  'drilldown.peakHour': 'Spitze',
  'drilldown.avgPerHour': 'Ø/Std.',
  'drilldown.total': 'Gesamt',
  'drilldown.bestDay': 'Bester Tag',
  'drilldown.weeklyAvg': 'Wochenschnitt',
  'drilldown.vsTarget': 'vs. Ziel',
  'drilldown.monthTotal': 'Monat gesamt',
  'drilldown.week1': 'Woche 1',
  'drilldown.week2': 'Woche 2',
  'drilldown.week3': 'Woche 3',
  'drilldown.week4': 'Woche 4',

  // ── Alert Strip ──
  'alerts.allOperational': 'Alle Systeme in Betrieb — keine aktiven Warnungen',
  'alerts.showLess': 'Weniger anzeigen',
  'alerts.showAll': 'Alle anzeigen',

  // ── Trucks Page ──
  'trucks.title': 'Ankünfte',
  'trucks.enRoute': 'Unterwegs',
  'trucks.waiting': 'Wartet',
  'trucks.weighIn': 'Eingangswägung',
  'trucks.loading': 'Verladung',
  'trucks.weighOut': 'Ausgangswägung',
  'trucks.departed': 'Abgefahren',
  'trucks.total': 'Gesamt',
  'trucks.loadingTimeline': 'Zeitachse der Verladungen',
  'trucks.siteMap': "Gelände jetzt",
  'trucks.siteLayout': 'Werksplan',
  'trucks.plant': 'WERK',
  'trucks.omyaJesenik': 'OMYA Pomezí',
  'trucks.truckCount': 'Lkw',
  'trucks.weighBridge': 'WAAGE',
  'trucks.searchPlaceholder': 'Lkw suchen...',

  // ── Truck Detail Sheet ──
  'truckDetail.overview': 'Übersicht',
  'truckDetail.timeline': 'Zeitachse',
  'truckDetail.order': 'Auftrag',
  'truckDetail.load': 'Ladung',
  'truckDetail.driver': 'Fahrer',
  'truckDetail.currentLoad': 'Aktuelle Ladung',
  'truckDetail.loaded': 'verladen',
  'truckDetail.remaining': 'offen',
  'truckDetail.progress': 'Fortschritt',
  'truckDetail.gate': 'Tor',
  'truckDetail.eta': 'Ankunft',
  'truckDetail.event': 'Ereignis',
  'truckDetail.linkedOrder': 'Verknüpfter Auftrag',
  'truckDetail.noLinkedOrder': 'Kein verknüpfter Auftrag',
  'truckDetail.documents': 'Dokumente',
  'truckDetail.material': 'Material',
  'truckDetail.targetWeight': 'Zielgewicht',
  'truckDetail.currentWeight': 'Aktuelles Gewicht',
  'truckDetail.timestamps': 'Zeitangaben',
  'truckDetail.arrived': 'Ankunft',
  'truckDetail.loadingStarted': 'Ladebeginn',
  'truckDetail.loadingTimeBySack': 'Ladezeit / Verpackungsart',

  // ── Planning Page ──
  'planning.title': 'Planung',
  'planning.week': 'Woche',
  'planning.thisWeek': 'Diese Woche',
  'planning.weekView': 'Wochenansicht',
  'planning.ganttView': 'Gantt-Ansicht',
  'planning.capacity': 'Kapazität',
  'planning.scheduled': 'Eingeplant',
  'planning.available': 'Frei',
  'planning.materials': 'Materialien',
  'planning.weeklySummary': 'Wochenübersicht',
  'planning.plannedOutput': 'Geplanter Ausstoss',
  'planning.actualOutput': 'Ist-Ausstoss',
  'planning.completion': 'Erfüllung',
  'planning.avgUtilization': 'Ø Auslastung',
  'planning.energyTariffs': 'Energietarife',
  'planning.off': 'NIEDRIG',
  'planning.peak': 'SPITZE',
  'planning.tariffStandard': 'MITTEL',
  'planning.tariffNegative': 'NEGATIV',
  'planning.schedule': '+ Einplanen',
  'addPlanning.title': 'Planung hinzufügen',
  'addPlanning.material': 'Material',
  'addPlanning.order': 'Auftrag',
  'addPlanning.selectOrder': 'Auftrag wählen',
  'addPlanning.noOrder': 'Ohne Auftrag',
  'addPlanning.energyTariff': 'Energietarif',
  'addPlanning.tariff': 'Tarif',
  'addPlanning.cancel': 'Abbrechen',
  'addPlanning.add': 'Hinzufügen',
  'planning.now': 'Jetzt',
  'planning.material.gcc': 'Kalkstein GCC',
  'planning.material.pcc': 'Kalkstein PCC',
  'planning.material.byproduct': 'Nebenprodukt',
  'planning.productionFlow': 'Produktionsfluss',
  'planning.productionFlowDesc': 'Gestein (Rohstoff) → Kalksteinprodukte (GCC/PCC) → Nebenprodukt (CaCO3). Bei der Gesteinsverarbeitung entstehen die Hauptprodukte und ein Nebenprodukt.',
  'planning.mainProduction': 'Hauptproduktion',
  'planning.byProduct': 'Nebenprodukt',
  'planning.fraction': 'Fraktion',
  'planning.fraction.sand': 'Sand',
  'planning.fraction.fine': 'Fein',
  'planning.fraction.standard': 'Standard',
  'planning.fraction.powder': 'Pulver',
  'planning.fractionCycleNote': 'Zykluszeit pro Tonne',
  'planning.packagingLine': 'Abpacklinie',
  'planning.packaging.bigBag': 'Big Bag (1 t)',
  'planning.packaging.bag25': 'Säcke 25 kg',
  'planning.packaging.bag50': 'Säcke 50 kg',
  'planning.packaging.bulk': 'Lose (Silo)',
  'planning.linkedTo': 'Gekoppelt an',
  'planning.linkedDeps': 'Gekoppelte Produktion',
  'planning.linkedDepsDesc': 'Die Produktion dieses Materials erfordert die parallele Produktion der aufgeführten Positionen.',
  'gantt.util': 'Ausl.',
  'gantt.planned': 'geplant',

  // ── Days of week ──
  'day.mon': 'Mo',
  'day.tue': 'Di',
  'day.wed': 'Mi',
  'day.thu': 'Do',
  'day.fri': 'Fr',
  'day.sat': 'Sa',
  'day.sun': 'So',

  // ── Orders Page ──
  'orders.title': 'Aufträge',
  'orders.totalOrders': 'Aufträge gesamt',
  'orders.totalValue': 'Gesamtwert',
  'orders.avgOrder': 'Ø Auftrag',
  'orders.fulfillmentRate': 'Erfüllungsquote',
  'orders.allStatuses': 'Alle Status',
  'orders.pending': 'Ausstehend',
  'orders.confirmed': 'Bestätigt',
  'orders.inProduction': 'In Produktion',
  'orders.produced': 'Produziert',
  'orders.dispatched': 'Versandt',
  'orders.delivered': 'Geliefert',
  'orders.searchPlaceholder': 'Nach Auftrag, Kunde oder Material suchen...',
  'orders.status': 'Status',
  'orders.number': '#',
  'orders.customer': 'Kunde',
  'orders.items': 'Positionen',
  'orders.progress': 'Fortschritt',
  'orders.value': 'Wert',
  'orders.delivery': 'Lieferung',
  'orders.showing': 'Angezeigt',
  'orders.of': 'von',
  'orders.ordersCount': 'Aufträgen',

  // ── Supply Chain ──
  'supplyChain.title': 'Produktionskette',
  'supplyChain.addWidget': 'Widget hinzufügen',
  'supplyChain.widgetAdded': 'Widget hinzugefügt',
  'supplyChain.widgetRemoved': 'Widget entfernt',
  'supplyChain.node.quarry': 'Steinbruch',
  'supplyChain.node.crusher': 'Brecher',
  'supplyChain.node.sorting': 'Sortierung',
  'supplyChain.node.packaging': 'Abpackung',
  'supplyChain.node.bulk': 'Lose',
  'supplyChain.node.dispatch': 'Versand',
  'supplyChain.node.silo': 'Silo',
  'supplyChain.crusherTariffBadge': 'Brecher – aktueller Tarif',
  'supplyChain.crusherCostNow': 'Kosten pro Tonne (jetzt)',
  'supplyChain.siloFillTime': 'Füllzeit',
  'supplyChain.siloCapacity': 'Kapazität',
  'supplyChain.siloContent': 'Inhalt',
  'supplyChain.bottleneck': 'Engpass',
  'supplyChain.legend': 'Legende',
  'supplyChain.legend.nodeStatus': 'Knotenstatus',
  'supplyChain.legend.operational': 'In Betrieb',
  'supplyChain.legend.warning': 'Warnung',
  'supplyChain.legend.errorBottleneck': 'Fehler / Engpass',
  'supplyChain.legend.flowStatus': 'Flussstatus',
  'supplyChain.legend.activeFlow': 'Aktiver Fluss',
  'supplyChain.legend.reducedFlow': 'Reduzierter Fluss',
  'supplyChain.legend.stopped': 'Gestoppt',
  'supplyChain.legend.capacity': 'Kapazität',
  'supplyChain.legend.capacityUnder60': '< 60 %',
  'supplyChain.legend.capacity60to85': '60–85 %',
  'supplyChain.legend.capacityOver85': '> 85 %',
  'supplyChain.status.operational': 'In Betrieb',
  'supplyChain.status.warning': 'Warnung',
  'supplyChain.status.error': 'Fehler',

  // ── SAP Integration ──
  'sap.title': 'SAP-Integration',
  'sap.heading': 'Integration SAP S/4HANA',
  'sap.subtitle': 'Bidirektionale Datensynchronisation',
  'sap.omyaDigitalPlant': 'OMYA Digital Plant',
  'sap.supplyChainTrucks': 'Produktionskette · Lkw',
  'sap.planningOrders': 'Planung · Aufträge',
  'sap.restApi': 'REST API',
  'sap.middleware': 'Middleware',
  'sap.dataMapping': 'Datenmapping',
  'sap.validationAuth': 'Validierung · Authentifizierung',
  'sap.rfcOdata': 'RFC / OData',
  'sap.dataFlows': 'Datenflüsse',
  'sap.syncStatus': 'Synchronisationsstatus',
  'sap.apiLog': 'API-Log',
  'sap.dataType': 'Datentyp',
  'sap.direction': 'Richtung',
  'sap.frequency': 'Häufigkeit',
  'sap.lastSync': 'Letzte Sync.',
  'sap.status': 'Status',
  'sap.productionOrders': 'Fertigungsaufträge',
  'sap.inventoryLevels': 'Lagerbestand',
  'sap.customerMaster': 'Kundenstammdaten',
  'sap.dispatchConfirmations': 'Versandbestätigungen',
  'sap.loadingPlans': 'Verladepläne',
  'sap.qualityResults': 'Qualitätsergebnisse',
  'sap.materialSpecs': 'Materialspezifikationen',
  'sap.financialData': 'Finanzdaten',
  'sap.realTime': 'Echtzeit',
  'sap.every5Min': 'Alle 5 min',
  'sap.daily': 'Täglich',
  'sap.onEvent': 'Bei Ereignis',
  'sap.every15Min': 'Alle 15 min',
  'sap.weekly': 'Wöchentlich',
  'sap.ppProduction': 'PP (Produktion)',
  'sap.mmMaterials': 'MM (Materialwirtschaft)',
  'sap.sdSales': 'SD (Vertrieb)',
  'sap.qmQuality': 'QM (Qualität)',
  'sap.pmMaintenance': 'PM (Instandhaltung)',
  'sap.fiFinance': 'FI (Finanzen)',
  'sap.recordsSynced': 'Datensätze synchronisiert',
  'sap.synchronized': 'Synchronisiert',
  'sap.delayed': 'Verzögert',
  'sap.time': 'Zeit',
  'sap.method': 'Methode',
  'sap.endpoint': 'Endpoint',
  'sap.duration': 'Dauer',
  'sap.infoTitle': 'Visuelles Mockup.',
  'sap.infoText': 'Es findet keine Datenübertragung statt. Die volle Integration mit SAP S/4HANA ist für Q3 2026 geplant, inkl. gesicherter API, SSO-Anmeldung, Audit-Logging und Echtzeit-Synchronisation.',

  // ── Login ──
  'login.welcomeBack': 'Willkommen zurück',
  'login.signInSubtitle': 'Melden Sie sich an, um die Übersicht zu öffnen',
  'login.email': 'E-Mail',
  'login.emailPlaceholder': 'vorname.nachname@omya.com',
  'login.password': 'Passwort',
  'login.forgot': 'Vergessen?',
  'login.passwordPlaceholder': 'Passwort eingeben',
  'login.signIn': 'Anmelden',
  'login.signingIn': 'Anmeldung läuft...',
  'login.demoMode': 'Demomodus — beliebige Zugangsdaten werden akzeptiert',

  // ── Production Order Dialog ──
  'prodDialog.utilization': 'Auslastung',
  'prodDialog.planned': 'Geplant',
  'prodDialog.actual': 'Ist',
  'prodDialog.productionProgress': 'Produktionsfortschritt',
  'prodDialog.offPeak': 'NIEDERTARIF',
  'prodDialog.peak': 'SPITZE',
  'prodDialog.shift': 'Schicht',
  'prodDialog.hourlyOutput': 'Stundenausstoss',
  'prodDialog.order': 'Auftrag',

  // ── Gantt View ──
  'gantt.now': 'Jetzt',

  // ── Shift labels ──
  'shift.morning': 'Früh',
  'shift.afternoon': 'Spät',
  'shift.night': 'Nacht',

  // ── Add Widget Dialog ──
  'widget.addTitle': 'Kennzahl-Widget hinzufügen',
  'widget.addDescription': 'Wählen Sie Knoten und Kennzahl für die Anzeige auf der Arbeitsfläche.',
  'widget.sourceNode': 'Quellknoten',
  'widget.selectNode': 'Knoten wählen...',
  'widget.metric': 'Kennzahl',
  'widget.selectMetric': 'Kennzahl wählen...',
  'widget.cancel': 'Abbrechen',
  'widget.add': 'Widget hinzufügen',
  'metric.oeeOverall': 'OEE gesamt',
  'metric.availability': 'Verfügbarkeit',
  'metric.performance': 'Leistung',
  'metric.quality': 'Qualität',
  'metric.utilization': 'Auslastung',
  'metric.currentOutput': 'Aktueller Ausstoss',
  'metric.maxCapacity': 'Max. Kapazität',
  'metric.activeAlerts': 'Aktive Warnungen',
  'metric.hoursRun': 'Betriebsstunden',

  // ── OEE Overlay ──
  'oee.plantOee': 'Werks-OEE',
  'oee.availability': 'Verfügbarkeit',
  'oee.performance': 'Leistung',
  'oee.quality': 'Qualität',
  'oee.throughput': 'Durchsatz',

  // ── Node Detail Panel ──
  'node.currentOutput': 'Aktueller Ausstoss',
  'node.oeeBreakdown': 'OEE-Aufschlüsselung',
  'node.availability': 'Verfügbarkeit',
  'node.performance': 'Leistung',
  'node.quality': 'Qualität',
  'node.overall': 'Gesamt',
  'node.material': 'Material',
  'node.order': 'Auftrag',
  'node.progress': 'Fortschritt',
  'node.throughput': 'Durchsatz',
  'node.uptime': 'Verfügbarkeit',
  'node.qualityRate': 'Qualitätsrate',
  'node.utilization': 'Auslastung',
  'node.performanceRadar': 'Leistungsradar',
  'node.speed': 'Geschwindigkeit',
  'node.energy': 'Energie',
  'node.output': 'Ausstoss',
  'node.actual': 'Ist',
  'node.target': 'Ziel',

  // ── Orders filter ──
  'orders.statusFilter': 'Status',

  // ── Visual Factory ──
  'visualFactory.title': 'Visual Factory',
  'visualFactory.panel.capacity': 'Kapazität und Auslastung',
  'visualFactory.panel.orders': 'Heutige Aufträge',
  'visualFactory.panel.trucks': 'Lkw aktuell',
  'visualFactory.panel.ote': 'Energietarif',
  'visualFactory.now': 'JETZT',
  'visualFactory.utilized': 'Ausgelastet',
  'visualFactory.free': 'Frei',
  'visualFactory.alerts': 'Warnungen',
  'visualFactory.shift': 'Schicht',
  'visualFactory.costPerTonne': 'Kosten / Tonne',
  'visualFactory.exitFullscreen': 'Vollbild beenden',
  'visualFactory.todayProduced': 'Heute produziert',
  'visualFactory.expected': 'Soll-Stand',
  'visualFactory.shiftRemaining': 'Rest der Schicht',
  'visualFactory.productionLines': 'Produktionslinien',
  'visualFactory.silosAndTrucks': 'Silos und Lkw',
  'visualFactory.target': 'Ziel',
  'visualFactory.fullIn': 'Voll in',
  'visualFactory.truckEta': 'Lkw',
  'visualFactory.collision': 'Kollision',
  'visualFactory.collisionLegend': 'Rot = Silo voll, bevor der Lkw kommt',
  'visualFactory.noTruck': 'Kein Lkw geplant',
  'visualFactory.expeditionToday': 'Versand heute',
  'visualFactory.trucksOnSite': 'Lkw im Werk',
  'visualFactory.waitingOver30': 'warten > 30 min',
  'visualFactory.maintenance': 'Instandhaltung',
  'visualFactory.daysSinceIncident': 'Tage ohne Unfall',
  'visualFactory.tickerPeak': 'Empfehlung: Mahlen feiner Fraktionen reduzieren und in den Niedertarif verschieben',
  'visualFactory.tickerNegative': 'Negativer Preis — guter Zeitpunkt für energieintensive Prozesse',
  'visualFactory.tickerOffPeak': 'Günstiger Tarif — guter Zeitpunkt zum Mahlen von Pulver und feinen Fraktionen',
  'visualFactory.tickerStandard': 'Standardtarif',
  'visualFactory.backToApp': 'Zurück zur App',
  'visualFactory.whatIsThis': 'Was sehe ich hier?',
  'visualFactory.bannerHint': 'Schwarze Linie = wo wir jetzt sein sollten. Weisser Balken = was wir produziert haben.',
  'visualFactory.linesHint': 'Status der 3 Produktionslinien. Grün = läuft im Soll, gelb = langsam, rot = gestoppt.',
  'visualFactory.silosHint': 'Silofüllstand + ETA der Lkw. Roter Rahmen = Silo ist voll, bevor der Lkw ankommt (Produktion stoppt).',
  'visualFactory.tariffTicker': 'Energietarif (untere Zeile)',
  'visualFactory.footerInfo': 'Untere Leiste — Versand, Instandhaltung, Sicherheit',
  'visualFactory.aboutIntro': 'Dieser Bildschirm ist für den TV in der Werkshalle gedacht. Ohne Anmeldung sieht jeder den Produktionsstand auf einen Blick. Aktualisierung alle 30 Sekunden.',
  'visualFactory.aboutBanner': 'Grosses Banner oben. Heute produzierte Tonnage vs. Tagesplan, plus geschätzte Restzeit der Schicht. Die schwarze senkrechte Linie zeigt den Wert, auf dem wir jetzt sein sollten (wenn alles nach Plan liefe).',
  'visualFactory.aboutLines': 'Drei Kacheln — eine pro Produktionslinie. Die farbige LED zeigt den Status (grün/gelb/rot nach ISA-101). Läuft eine Linie langsam oder steht sie, zeigt die Kachel den Grund und seit wann.',
  'visualFactory.aboutSilos': 'Hauptteil des Bildschirms. Für jedes Silo: aktueller Füllstand, Berechnung, wann es beim aktuellen Produktionstempo voll ist, und ETA des nächsten Lkw. Roter Rahmen = Kollision: Das Silo läuft über, bevor der Lkw ankommt → sofort die Transportdisposition anrufen.',
  'visualFactory.aboutFooter': 'Versand heute (Aufteilung CZ/PL), Anzahl Lkw im Werk (und wie viele davon über 30 Minuten warten), laufende Instandhaltung mit ETA, Tage ohne Unfall.',
  'visualFactory.aboutTicker': 'Aktueller OTE-Energietarif + Empfehlung für die Produktionsplanung (Spitze = feine Fraktionen reduzieren, Niedertarif/negativ = guter Zeitpunkt).',
  'visualFactory.aboutFooterNote': 'Keine sensiblen Daten (Fahrernamen, Margen, polnische Kunden). Der Bildschirm ist innerhalb des Werks öffentlich.',

  // ── Status (utils.js) ──
  'status.ok': 'OK',
  'status.warning': 'Warnung',
  'status.problem': 'Problem',

  // ── Dashboard additions ──
  'dash.arrivals.title': 'Ankünfte heute',
  'dash.arrivals.urgency': 'Nachfrage bei Spediteuren um 13:00',
  'dash.arrivals.open': 'Ankünfte öffnen',
  'dash.arrivals.informed': 'Mit Information',
  'dash.parking.title': 'Parkplatz Jeseník',
  'dash.parking.month': 'Monat',
  'dash.parking.source': 'Kosten laut Kunde (Schätzung)',
  'dash.parking.goal': 'Ziel: Parkplatzbedarf dank avisierter Ankünfte senken.',
  'dash.mobileWarning': 'Hinweis — Die App ist für PC optimiert. Auf dem Smartphone funktioniert sie eventuell nicht vollständig.',
  'dash.productionScorecard': 'Produktionsbewertung',
  'dash.productionScorecardDesc': 'Das Modul bewertet den Produktionsstand — Umsetzung durch externen Anbieter',

  // ── Trucks ──
  'trucks.weighBridgeLabel': 'Waage',
  'trucks.wbActive': 'Aktiv',
  'trucks.wbIdle': 'Leerlauf',
  'trucks.wbLast': 'Zuletzt',
  'trucks.loadingSlots': 'Ladezeitfenster',
  'trucks.addSlot': 'Slot hinzufügen',
  'trucks.slotFree': 'Frei',
  'trucks.qr.dontComeNow': 'Jetzt nicht kommen',
  'trucks.qr.youCanComeSlotFree': 'Sie können kommen, Slot ist frei',
  'trucks.qr.delay30': 'Ankunft um 30 min verschieben',
  'trucks.qr.goToWeighbridge': 'Fahren Sie auf die Waage',
  'trucks.qr.waitAtGate': 'Warten Sie am Tor',
  'trucks.dm.hourAway': 'Bin eine Stunde entfernt',
  'trucks.dm.in45': 'Komme in 45 min',
  'trucks.dm.atGate': 'Bin am Tor',
  'trucks.dm.loadingDone': 'Verladung fertig?',
  'trucks.dm.thanksDriving': 'Danke, fahre los',
  'trucks.toast.messageSent': 'Nachricht gesendet (Demo)',
  'trucks.noMessagesYet': 'Noch keine Nachrichten',
  'trucks.typeMessage': 'Nachricht schreiben...',
  'trucks.simulateDriverMessage': 'Fahrernachricht simulieren',
  'truckDetail.communication': 'Kommunikation',
  'truckDetail.calling': 'Rufe an',

  // ── Orders / Layout / Header ──
  'layout.digitalPlant': 'DIGITAL PLANT',
  'header.markAllReadToast': 'Alle Benachrichtigungen als gelesen markiert',
  'orders.actionSimulated': 'Aktion simuliert — Demomodus',
  'orders.confirm': 'Bestätigen',
  'orders.dispatch': 'Versenden',
  'orders.invoice': 'Rechnung',
  'orders.tab.overview': 'Übersicht',
  'orders.tab.items': 'Positionen',
  'orders.tab.timeline': 'Zeitachse',
  'orders.tab.delivery': 'Lieferung',
  'orders.ico': 'Firmen-ID',
  'orders.createdAt': 'Erstellt',
  'orders.confirmedAt': 'Bestätigt',
  'orders.material': 'Material',
  'orders.quantity': 'Menge',
  'orders.pricePerTon': 'Preis/t',
  'orders.total': 'Gesamt',
  'orders.productionProgress': 'Produktionsfortschritt',
  'orders.linkedTrucks': 'Verknüpfte Lkw',
  'orders.noTrucks': 'Keine Lkw',
  'orders.certificates': 'Zertifikate',
  'orders.noCertificates': 'Noch keine Zertifikate',

  // ── Planning ──
  'plan.howItWorks': 'Wie funktioniert die Planung?',
  'plan.howItWorksDesc': 'Das Planungsmodul optimiert die Produktion anhand der Eingangsdaten und erstellt einen Plan für alle Produktionslinien.',
  'plan.input': 'Eingabe',
  'plan.inputOrders': 'Aufträge und benötigte Materialien',
  'plan.inputCapacities': 'Kapazitäten der Produktionslinien',
  'plan.inputAvailability': 'Verfügbarkeit von Materialien und Rohstoffen',
  'plan.inputTariffs': 'Energietarife (Spitze / Niedertarif)',
  'plan.output': 'Ausgabe',
  'plan.outputWeeklyPlan': 'Wöchentlicher Produktionsplan (Tabelle / Gantt)',
  'plan.outputAssignment': 'Zuordnung der Materialien zu Linien und Schichten',
  'plan.outputTariffOpt': 'Optimierung nach Energietarifen',
  'plan.outputTonnes': 'Geplanter und tatsächlicher Ausstoss in Tonnen',
  'plan.oteOverlay': 'OTE-Ebene',
  'plan.oteOverlayToggle': 'OTE-Energieebene umschalten',
  'plan.oteSpotNote': 'OTE Spot, CZK/MWh, ohne MwSt. und Netzentgelte',
  'plan.oteSpotDaily': 'OTE Spot — Tageskurve',
  'plan.oteRecord': 'Rekord 5/2024',
  'plan.oteTypical': 'Typischer Tag',
  'plan.min': 'Min',
  'plan.avg': 'Ø',
  'plan.max': 'Max',
  'plan.inNegative': 'im Minus',
  'plan.negativeRecordSource': '• Minimum −138,75 EUR/MWh • Quelle OTE a.s.',
  'plan.czkPerMWh': 'CZK/MWh',
  'plan.annualSavingsPotential': 'Jährliches Einsparpotenzial',
  'plan.savingsAssumption': 'Verlagerung von 50 % des Mahlens in Spitzenzeiten in die Niedertarif- bzw. Negativphasen der OTE.',
  'plan.czkPerYear': 'CZK/Jahr',
  'plan.czkPerWeek': 'CZK/Woche',
  'plan.pctOfPowerBill': '% der Stromrechnung',
  'plan.specificEnergy': 'Spezifischer Mahlverbrauch',
  'plan.peakTonnageWeek': 'Tonnage in Spitzenzeit (Woche)',
  'plan.baselineNoOpt': 'Baseline (ohne Optimierung)',
  'plan.czk': 'CZK',
  'plan.assumptionsTuning': 'Die Annahmen gleichen wir mit Petrs tatsächlichem Verbrauch ab.',

  // ── Node detail panel ──
  'node.tab.overview': 'Übersicht',
  'node.tab.production': 'Produktion',
  'node.tab.maintenance': 'Instandhaltung',
  'node.tab.connections': 'Verbindungen',
  'node.currentBatch': 'Aktuelle Charge',
  'node.output24h': 'Ausstoss 24 h',
  'node.weeklyOutputVsTarget': 'Wochenausstoss vs. Ziel',
  'node.equipment': 'Anlage',
  'node.manufacturer': 'Hersteller',
  'node.model': 'Modell',
  'node.installed': 'Installiert',
  'node.operatingHours': 'Betriebsstunden',
  'node.nextMaintenance': 'Nächste Wartung',
  'node.days': 'Tage',
  'node.maintenanceHistory': 'Wartungshistorie',
  'node.date': 'Datum',
  'node.type': 'Typ',
  'node.description': 'Beschreibung',
  'node.duration': 'Dauer',
  'node.unplanned': 'Ungeplant',
  'node.scheduled': 'Geplant',
  'node.alerts': 'Warnungen',
  'node.linkedOrders': 'Verknüpfte Aufträge',
  'node.noLinkedOrders': 'Keine verknüpften Aufträge',
  'node.linkedTrucks': 'Verknüpfte Lkw',
  'node.noLinkedTrucks': 'Keine Lkw an diesem Knoten',

  // ── Mock data (dynamic content used in alerts, timelines, line labels) ──
  'mock.line1': 'Linie 1',
  'mock.line2': 'Linie 2',
  'mock.line3': 'Linie 3',
  'mock.alert.line2Overload': 'Linie 2 – Überlastung (92 %)',
  'mock.alert.noInfoLoadings': 'Verladungen ohne Information – Nachfrage bei Spediteuren um 13:00',
  'mock.alert.pstQueue': 'Tor PST – 3 Lkw warten',
  'mock.alert.dispatchOk': 'Versand – in Ordnung',
  'mock.alert.crusherBearingTemp': 'Lagertemperatur des Brechers steigt',
  'mock.alert.tariffPeakSwitch': 'Tarifwechsel auf SPITZE um 14:00',
  'mock.alert.orderPending': 'Auftrag ORD-2024-1845 wartet auf Bestätigung',
  'mock.alert.truckEta45': 'Lkw 5L9 2341 kommt in 45 min',
  'mock.line.stopReason.slowMillVibration': 'Mühle langsam — Vibration über Grenzwert',
  'mock.event.dispatch': 'Abfahrt vom Depot',
  'mock.event.arriveGate': 'Ankunft am Tor',
  'mock.event.weighEmpty123': 'Wägung: 12,3 t (leer)',
  'mock.event.weighEmpty128': 'Wägung: 12,8 t (leer)',
  'mock.event.weighEmpty131': 'Wägung: 13,1 t (leer)',
  'mock.event.weigh125': 'Wägung: 12,5 t',
  'mock.event.weigh130': 'Wägung: 13,0 t',
  'mock.event.weighInProgress': 'Wägung läuft',
  'mock.event.loadingStartedPST': 'Verladung an PST begonnen',
  'mock.event.loadingStartedCLS': 'Verladung an CLS begonnen',
  'mock.event.loadingStarted': 'Verladung begonnen',
  'mock.event.weighOut365': 'Ausgangswägung: 36,5 t',
  'mock.event.weighOut368': 'Ausgangswägung: 36,8 t (beladen)',
  'mock.event.dispatched': 'Versandt',
  'mock.event.arrived': 'Angekommen',
  'mock.event.departed': 'Abgefahren',
  'mock.event.departedFacility': 'Werk verlassen',
  'mock.event.waitingGate': 'Wartet auf Torzuweisung',
  'mock.event.waitingSlot': 'Wartet auf Slot',
  'mock.note.received': 'Eingegangen',
  'mock.note.receivedEmail': 'Auftrag per E-Mail eingegangen',
  'mock.note.receivedPhone': 'Telefonisch eingegangen',
  'mock.note.receivedPortal': 'Über Portal eingegangen',
  'mock.note.receivedOrderEmail': 'Auftrag per E-Mail eingegangen',
  'mock.note.receivedOrderPortal': 'Auftrag über Portal eingegangen',
  'mock.note.receivedOrder': 'Auftrag eingegangen',
  'mock.note.confirmed': 'Bestätigt',
  'mock.note.confirmedSales': 'Vom Vertrieb bestätigt',
  'mock.note.confirmedSalesTeam': 'Vom Vertriebsteam bestätigt',
  'mock.note.started': 'Begonnen',
  'mock.note.startedLine1': 'Auf Linie 1 begonnen',
  'mock.note.startedLine2': 'Auf Linie 2 begonnen',
  'mock.note.startedLine3': 'Auf Linie 3 begonnen',
  'mock.note.productionStarted': 'Produktion begonnen',
  'mock.note.productionStartedLine1': 'Produktion auf Linie 1 begonnen',
  'mock.note.productionStartedLine2': 'Produktion auf Linie 2 begonnen',
  'mock.note.productionDone': 'Produktion abgeschlossen',
  'mock.note.productionDoneWaiting': 'Produktion abgeschlossen, wartet auf Versand',
  'mock.note.done': 'Abgeschlossen',
  'mock.note.nightShift': 'Nachtschicht',
  'mock.note.dispatched': 'Versandt',
  'mock.note.dispatchedTwoTrucks': 'Versandt – 2 Lkw',
  'mock.note.dispatchedDopravaPlus': 'Versandt über Doprava Plus',
  'mock.note.loadedDispatched': 'Verladen und versandt',
  'mock.note.loadedOnTruck1J4': 'Verladen auf Lkw 1J4 9921',
  'mock.note.delivered': 'Geliefert',
  'mock.note.deliveredSigned': 'Geliefert und unterschrieben',
  'mock.nodeAlert.vibrationOverThreshold': 'Vibrationssensor über Grenzwert',
  'mock.nodeAlert.bearingTemp78': 'Lagertemperatur steigt – 78 °C',
  'mock.nodeAlert.crusherChamberWear72': 'Verschleiss Brecherkammer 72 %',
  'mock.dm.hourAway': 'Bin eine Stunde entfernt',
  'mock.dm.gateReady': 'Verstanden, Tor PST wird vorbereitet',
  'mock.dm.arriveIn45': 'Komme in 45 min',
  'mock.dm.holdSlot': 'Bitte jetzt nicht kommen, wir warten auf einen freien Slot',
  'mock.dm.waitingParking': 'OK, warte auf dem Parkplatz',
  'mock.dm.slotFree': 'Sie können kommen, Slot ist frei',
  'mock.dm.atGate': 'Bin am Tor',
  'mock.dm.goToScale': 'Fahren Sie auf die Waage',
  'mock.dm.loadingDone': 'Verladung fertig?',
  'mock.dm.goToExitScale': 'Ja, fahren Sie zur Ausgangswaage',
  'mock.dm.delay30': 'Ankunft um 30 min verschieben',
  'mock.dm.arriveLater': 'Verstanden, komme später',
  'mock.dm.eta45': 'ETA 45 Minuten',
  'mock.dm.preparingCLS': 'Danke, wir bereiten den Slot CLS vor',
  'mock.ote.historicalLabel': '12. 5. 2024 (Sonntag)',
  'mock.ote.typicalLabel': 'Typischer Arbeitstag',
  'mock.equipment.crusher': 'Brecher',
  'mock.day.Po': 'Mo',
  'mock.day.Út': 'Di',
  'mock.day.St': 'Mi',
  'mock.day.Čt': 'Do',
  'mock.day.Pá': 'Fr',
  'mock.day.So': 'Sa',
  'mock.day.Ne': 'So',
  // ── Příjezdy a nakládky / urgence ──
  'arrivals.state.no-info': 'Ohne Information',
  'arrivals.state.not-coming': 'Kommt nicht',
  'arrivals.state.no-power': 'Keine Lenkzeit',
  'arrivals.state.rescheduled': 'Umgeplant',
  'arrivals.state.confirmed': 'Bestätigt',
  'arrivals.state.en-route': 'Unterwegs (GPS)',
  'arrivals.state.on-site': 'Im Werk',
  'arrivals.state.loaded': 'Verladen',
  'arrivals.channel.sms': 'SMS',
  'arrivals.channel.whatsapp': 'WhatsApp',
  'arrivals.channel.email': 'E-Mail',
  'arrivals.channel.phone': 'Telefon',
  'arrivals.channel.voice': 'Sprachanruf',
  'arrivals.channel.link': 'Link für Fahrer',
  'arrivals.channel.gps': 'GPS',
  'arrivals.channel.system': 'System',
  'arrivals.channel.sap': 'SAP',
  'arrivals.perHour': 'Erwartete Ankünfte pro Stunde',
  'arrivals.perHourHint': 'Laut ETA, sonst laut Plan. Ohne Ladezeitfenster, nur Übersicht der Spitzen.',
  'arrivals.known': 'Mit Information',
  'arrivals.unknown': 'Ohne Information',
  'arrivals.gateCapacity': 'Torkapazität',
  'arrivals.filter.all': 'Alle',
  'arrivals.filter.attention': 'Handlungsbedarf',
  'arrivals.filter.open': 'Nicht verladen',
  'arrivals.filter.loaded': 'Verladen',
  'arrivals.filter.risk': 'Hohes Risiko',
  'ai.risk.label': 'Risiko Nichterscheinen',
  'ai.risk.high': 'Hohes Risiko',
  'ai.risk.medium': 'Mittleres Risiko',
  'ai.risk.low': 'Geringes Risiko',
  'ai.risk.reason.carrier': 'Der Spediteur erschien in 30 Tagen bei {pct} % der Verladungen ohne Avis nicht',
  'ai.risk.reason.noInfo': 'Noch keine Information vom Spediteur',
  'ai.risk.reason.noPower': 'Der Fahrer hat keine Lenkzeit mehr',
  'ai.risk.reason.rescheduled': 'Bereits einmal umgeplant',
  'ai.risk.reason.confirmed': 'Der Spediteur hat die Ankunft bestätigt',
  'ai.risk.reason.enRoute': 'Der Lkw ist unterwegs (GPS)',
  'ai.risk.reason.afternoon': 'Nachmittagsverladung, mehr Nichterscheinen',
  'ai.risk.reason.outOfHours': 'Spediteur {n}× in 30 Tagen ohne Lenkzeit',
  'ai.risk.reason.noPlate': 'Aus dem Import, noch ohne Kennzeichen',
  'ai.risk.note': 'Schätzung aus der Historie des Spediteurs und dem heutigen Stand, kein trainiertes Modell.',
  'arrivals.type.all': 'Alle',
  'arrivals.type.silo': 'Silo',
  'arrivals.type.pallet': 'Paletten',
  'arrivals.searchPlaceholder': 'Kennzeichen, Spediteur, Fahrer, Lieferung suchen...',
  'arrivals.emptyFilter': 'Nichts anzuzeigen. Alle Verladungen in diesem Filter sind erledigt.',
  'arrivals.plan': 'Plan',
  'arrivals.eta': 'Ankunft',
  'arrivals.tomorrow': 'morgen',
  'arrivals.loadedAt': 'Verladen',
  'arrivals.toPlanner': 'An Disponenten übergeben',
  'arrivals.powerFrom': 'Lenkzeit ab',
  'arrivals.plannedToday': 'Heute geplant',
  'actions.bannerText': 'Verladungen brauchen eine Aktion – Nachfassen, Anruf oder Umplanen.',
  'actions.open': 'Aktionen öffnen',
  'actions.title': 'Aktionen',
  'actions.progress': 'Erledigt',
  'actions.hint': 'Verladungen, bei denen etwas zu tun ist. Was Sie erledigen, verschwindet aus der Liste.',
  'actions.empty': 'Alles erledigt',
  'actions.emptyHint': 'Keine Verladung braucht gerade eine Aktion.',
  'actions.urge': 'Nachfassen',
  'actions.urged': 'Nachgefasst',
  'actions.urgedToast': 'Nachfrage an den Spediteur gesendet',
  'actions.call': 'Anrufen',
  'actions.link': 'Link für Disponenten',
  'actions.replan': 'Umplanen',
  'actions.resolve': 'Erledigt',
  'actions.newTime': 'Neue Uhrzeit',
  'actions.replannedTo': 'Vom Planer umgeplant auf',
  'actions.note': 'Notiz',
  'actions.notePlaceholder': 'Was ist passiert (z. B. telefonisch vereinbart)',
  'actions.resolvedNote': 'Vom Planer erledigt',
  'actions.confirm': 'Bestätigen',
  'arrivals.tabToday': 'Heutige Verladungen',
  'arrivals.readyToConnect': 'Bereit zur Anbindung',
  'arrivals.showTranscript': 'Gesprächsprotokoll anzeigen',
  'arrivals.hideTranscript': 'Protokoll ausblenden',
  'arrivals.urgency.title': 'Nachfrage bei Spediteuren',
  'arrivals.urgency.rule': 'Prüfung um 13:00 · Eskalation nach 30 min: 2. Kanal → Sprachanruf',
  'arrivals.urgency.approval': 'Mit Freigabe',
  'arrivals.urgency.approvalHint': 'Das System bereitet die Nachrichten vor, der Disponent sendet sie mit einem Klick.',
  'arrivals.urgency.auto': 'Voll automatisch',
  'arrivals.urgency.autoHint': 'Das System fragt selbst nach und meldet dem Disponenten nur, was es nicht lösen konnte.',
  'arrivals.urgency.run': 'Prüfung 13:00 starten',
  'arrivals.urgency.queue': 'Nachzufragen',
  'arrivals.urgency.sendAll': 'Bei allen nachfragen',
  'arrivals.urgency.result': 'Verladungen ohne Information',
  'arrivals.urgency.resultHint': 'Der Disponent kümmert sich nur um den Rest. Manuelles Abtelefonieren entfällt.',
  'arrivals.urgency.reset': 'Erneut abspielen',
  'arrivals.urgency.empty': 'Um 13:00 vergleicht das System den Verladeplan mit dem Ist-Stand und kontaktiert die Spediteure, von denen wir nichts wissen.',
  'arrivals.detail.carrier': 'Spediteur',
  'arrivals.detail.prefers': 'bevorzugt',
  'arrivals.detail.emailDemo': 'E-Mail geöffnet (Demo)',
  'arrivals.detail.driver': 'Fahrer',
  'arrivals.detail.name': 'Name',
  'arrivals.detail.power': 'Lenkzeit',
  'arrivals.detail.powerUnknown': 'unbekannt',
  'arrivals.detail.fromPlant': 'vom Werk',
  'arrivals.detail.parking': 'Parkplatz',
  'arrivals.detail.parkingJesenik': 'Auffangparkplatz Jeseník',
  'arrivals.detail.loading': 'Verladung',
  'arrivals.detail.order': 'Lieferung (SAP)',
  'arrivals.detail.customer': 'Kunde',
  'arrivals.detail.material': 'Material',
  'arrivals.detail.type': 'Typ',
  'arrivals.detail.communication': 'Kommunikation',
  'arrivals.detail.noMessages': 'Noch keine Kommunikation',
  'arrivals.detail.auto': 'automatisch',
  'arrivals.ai.confirmed': 'KI: bestätigt, Ankunft {time}',
  'arrivals.ai.rescheduled': 'KI: heute nicht, umgeplant auf morgen {time}',
  'arrivals.ai.noPower': 'KI: Fahrer ohne Lenkzeit, Verladung morgen 6:00, parkt in Jeseník',
  'arrivals.log.check': 'Prüfung 13:00: {total} Verladungen ohne Information. {gps} per GPS geortet, {queue} zum Nachfragen.',
  'arrivals.log.gps': 'GPS: Fahrzeug ist {km} km vom Werk entfernt, ETA {time}. Keine Nachfrage nötig.',
  'arrivals.log.gpsShort': 'GPS: {km} km vom Werk, ETA {time}',
  'arrivals.log.sapNew': 'Neue Lieferung aus SAP {order}, dem Spediteur {carrier} zugewiesen.',
  'arrivals.log.escalate': '30 min ohne Antwort ({ids}): versuche zweiten Kanal.',
  'arrivals.log.call': 'Sprachanruf: {name}, {phone}',
  'arrivals.log.callNoAnswer': 'Sprachanruf: {name} nimmt nicht ab. An Disponenten übergeben.',
  'arrivals.log.callNoAnswerShort': 'Anruf nicht angenommen, an Disponenten übergeben',
  'arrivals.log.done': 'Nachfrage abgeschlossen. Übrig ist nur, was ein Mensch klären muss.',

  // ── Help tips (#113) ──
  'help.label': "Hilfe",
  'help.states.title': "Lkw-Status",
  'help.states.text': "Wie viele Lkw in welchem Status sind. Grün = in Ordnung, Orange = Achtung, Rot = Problem. Klicken Sie auf einen Lkw in der Liste für Details.",
  'help.perHour.title': "Ankünfte pro Stunde",
  'help.perHour.text': "Wie viele Lkw in jeder Stunde ankommen sollen. Hoher Balken = Stau am Tor. Lohnt sich zu verteilen.",
  'help.filters.title': "Filter",
  'help.filters.text': "Klicken Sie, um nur die Lkw zu sehen, die Sie interessieren. Erneut klicken hebt den Filter auf.",
  'help.actions.title': "Aktionen",
  'help.actions.text': "Was jetzt zu tun ist. Das Wichtigste oben. Erledigen, und der Eintrag verschwindet.",
  'help.followUp.title': "Nachfassen bei Spediteuren",
  'help.followUp.text': "Um 13:00 prüft das System, wer die Ladung für morgen nicht bestätigt hat, und schreibt dem Spediteur. Sie müssen niemanden anrufen.",
  'help.approval.title': "Automatisch oder mit Freigabe",
  'help.approval.text': "Automatisch: Nachrichten gehen von selbst raus. Mit Freigabe: Sie sehen sie zuerst und bestätigen mit einem Klick.",
  'help.risk.title': "Ausfallrisiko",
  'help.risk.text': "Wie wahrscheinlich es ist, dass der Lkw nicht kommt. Berechnet aus der Historie des Spediteurs. Hohes Risiko = früher anrufen.",
  'help.announce.title': "Link für den Disponenten",
  'help.announce.text': "Schickt dem Spediteur einen Link. Der Disponent trägt Kennzeichen und Fahrer selbst ein. Kein Abtippen aus E-Mails.",
  'help.reply.title': "Antwort simulieren",
  'help.reply.text': "Schreiben Sie eine Antwort wie ein Spediteur, z. B. „wir kommen erst morgen“. Die KI liest sie und schlägt Änderungen vor.",
  'help.replan.title': "Umplanungsvorschlag",
  'help.replan.text': "Die KI schlägt eine neue Ladezeit vor. Wenn Sie einverstanden sind, klicken Sie auf Übernehmen. Sonst nichts tun.",
  'help.voice.title': "KI-Sprachanruf",
  'help.voice.text': "Die KI ruft den Disponenten an und fragt nach der Ankunft. Das Ergebnis wird bei der Ladung gespeichert.",
  'help.doc.title': "Beleg vom Foto",
  'help.doc.text': "Fotografieren Sie Lieferschein oder CMR. Die KI liest die Zahlen aus und trägt sie ein. Prüfen und bestätigen.",
  'help.importPaste.title': "Plan einfügen",
  'help.importPaste.text': "Kopieren Sie den Plan aus Excel oder einer E-Mail und fügen Sie ihn hier ein. Das System legt die Ladungen an.",
  'help.importPhoto.title': "Plan vom Foto",
  'help.importPhoto.text': "Plan nur auf Papier? Fotografieren oder PDF hochladen. Die KI tippt ihn für Sie ab.",
  'help.period.title': "Zeitraum",
  'help.period.text': "Wählen Sie den Zeitraum. Alle Diagramme unten werden neu berechnet.",
  'help.kpis.title': "Kennzahlen",
  'help.kpis.text': "Vier Zahlen, an denen Sie sehen, ob es funktioniert. Der Pfeil zeigt die Änderung gegenüber der Zeit vor dem Pilot.",
  'help.ask.title': "Fragen",
  'help.ask.text': "Stellen Sie eine Frage in normalen Worten, z. B. „Welcher Spediteur ist am häufigsten zu spät?“. Die KI antwortet aus den Zahlen dieser Seite.",
  'help.carriers.title': "Spediteure",
  'help.carriers.text': "Wer gut fährt und wer nicht. Rot = kommt oft nicht. Klicken Sie auf einen Spediteur für mehr.",
  'help.value.title': "Wert des Pilots",
  'help.value.text': "Wie viel das System Ihnen pro Monat spart. Die Zahlen in den Feldern können Sie ändern, das Ergebnis wird neu berechnet.",
  'help.heatmap.title': "Wann Lkw kommen",
  'help.heatmap.text': "Dunkleres Feld = mehr Lkw an diesem Tag und zu dieser Stunde. So sehen Sie, wann am meisten los ist.",
  'help.reports.title': "Berichte",
  'help.reports.text': "Fertige Übersichten für die Besprechung. Einfach öffnen, drucken oder senden.",
  'help.rating.title': "Spediteurbewertung",
  'help.rating.text': "Monatliches Zeugnis für den Spediteur. Drucken oder als PDF senden. Die Hilfe wird nicht gedruckt.",
  'help.energy.title': "Mahlplan",
  'help.energy.text': "Die KI schlägt vor, wann gemahlen wird, damit es auf günstigen Strom fällt. Gefällt Ihnen der Plan, übernehmen Sie ihn.",
  'help.ai.title': "KI oder KI-Demo",
  'help.ai.text': "KI = Claude hat diese Antwort gerade geschrieben. KI-Demo = vorbereitete Beispielantwort, wenn die KI nicht eingeschaltet ist.",
  // ── Site now (#115) ──
  'site.title': "Werksgelände jetzt",
  'site.summary': "{total} Lkw sind auf dem Gelände.",
  'site.lateSummary': "{late} davon sind länger als {limit} Minuten hier.",
  'site.lateHint': "Steht zu lange hier. Klären Sie warum – Warten kostet Geld.",
  'site.onSite': "auf dem Gelände",
  'site.empty': "Niemand",
  'site.zone.queue': "Warteschlange am Tor",
  'site.zone.PST': "Verladung PST (Paletten)",
  'site.zone.CLS': "Verladung CLS (Silos)",
  'site.zone.weighbridge': "Waage",
  'help.siteNow.title': "Gelände jetzt",
  'help.siteNow.text': "Wer gerade auf dem Gelände ist und wo. Große Zahl = Zeit an dieser Stelle, kleine = Zeit auf dem Gelände insgesamt. Rot = mehr als 45 Minuten, klicken und klären.",
  // ── Today's sections (#117) ──
  'arrivals.section.action': "Handlungsbedarf",
  'arrivals.section.onSite': "Auf dem Gelände",
  'arrivals.section.enRoute': "Unterwegs",
  'arrivals.section.confirmed': "Bestätigt",
  'arrivals.section.later': "Verschoben",
  'arrivals.section.loaded': "Verladen",
  'arrivals.typeLabel': "Typ",
  // ── Recommended action (#118) ──
  'actions.more': "Mehr…",
  'actions.recommended': "Empfohlen",
  'actions.reason.noInfo': "der Spediteur hat sich noch nicht gemeldet, schicken Sie eine Nachricht.",
  'actions.reason.noAnswer': "nachgefasst und keine Antwort, rufen Sie an.",
  'actions.reason.noPower': "der Fahrer hat keine Lenkzeit mehr, verschieben Sie die Ladung.",
  'arrivals.urgency.bar.idle': "Die Prüfung ist noch nicht gelaufen.",
  'arrivals.urgency.bar.review': "Nachrichten warten auf den Versand.",
  'arrivals.urgency.bar.done': "Die Prüfung ist fertig.",
  'arrivals.urgency.bar.sending': "Nachrichten an Spediteure werden gesendet…",
  'arrivals.urgency.barToggle': "Verlauf des Nachfassens anzeigen",
};

export default de;
